import { IRecarga } from "../../../../pages/CongelamentoCNPJ/Congelamentos/Recargas/interfaces";
import { api } from "../../../apiAxios";
import { getToken } from "../../../LStorage/token";
import { urlHttpGov } from "../../../urls";

class RecargasService {
    private readonly baseURL = `${urlHttpGov}/congelamento-cnpj/recarga`;

    async get(signal?: AbortSignal): Promise<IRecarga[]> {

        const { data } = await api.get(`${this.baseURL}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data;
    }

    async findById(id: string, signal?: AbortSignal): Promise<IRecarga> {

        const { data } = await api.get(`${this.baseURL}/${id}`,
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

    async create(valor: number, signal?: AbortSignal) {
        const { data } = await api.post(`${this.baseURL}`,
            { valor },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }

    async update(id: string, valor: number, signal?: AbortSignal) {

        const { data } = await api.put(`${this.baseURL}/${id}`,
            { valor },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken()
                },
                signal
            });

        return data
    }
}

export default new RecargasService();
